/**
 * capitalizeFirstLetter() - make first letter of the string capitalized
 * @param {string} string
 * @returns capitalized string
 */
export const capitalizeFirstLetter = (string) => {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : string;
};
